/* eslint-disable no-undef */
import axios from 'axios';
import Cookies from 'js-cookie';

export const getApiUrl = () => {
  if (
    process.env.VITE_NODE_ENV === 'production' ||
    import.meta.env.VITE_API_MODE === 'PROD'
  ) {
    return 'https://api.profoundpros.com/v1';
  }
  if (process.env.VITE_NODE_ENV === 'development') {
    return 'http://localhost:5001/v1';
  }
};

export const getDomain = () => {
  if (process.env.VITE_NODE_ENV === 'development') {
    return 'localhost';
  }
  if (process.env.VITE_NODE_ENV === 'production') {
    return '.profoundpros.com';
  }
};

export const getAppUrl = (app) => {
  if (app === 'admin') {
    if (process.env.VITE_NODE_ENV === 'production') {
      return 'https://admin.profoundpros.com/';
    } else {
      return 'http://localhost:5174/';
    }
  }
  if (app === 'mega') {
    if (process.env.VITE_NODE_ENV === 'production') {
      return 'https://mega.profoundpros.com/';
    } else {
      return 'http://localhost:5175/';
    }
  }
};

const getToken = () => {
  const token = Cookies.get('token');
  return token;
};

export const clearToken = () => {
  Cookies.remove('token', { domain: getDomain() });
};

export const useAuth = () => {
  axios.interceptors.request.use((config) => {
    if (!config.url.includes('s3.us-west-2')) {
      config.headers['Authorization'] = `Bearer ${getToken()}`;
    }
    return config;
  });
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (
        error.response.status === 401 &&
        window.location.pathname !== '/login'
      ) {
        clearToken();
        window.location.replace('/login');
        throw error;
      }
      throw error;
    }
  );
};

export const formatAndThrowApiError = (err) => {
  let errMessage = 'Something went wrong.';
  if (err.response?.status === 500) {
    errMessage = 'Something went wrong.';
  } else if (err.response?.data?.message) {
    errMessage = err.response.data.message;
  } else if (err.message) {
    errMessage = err.message;
  }
  throw Error(errMessage);
};
